import React from "react";

import {
  BorderColor as BorderColorIcon,
  Delete as DeleteIcon,
} from "@mui/icons-material";
import { Box, IconButton, Typography } from "@mui/material";
import { format } from "date-fns";
import { observer } from "mobx-react-lite";
import { makeStyles } from "tss-react/mui";

import useDialogState from "@/hooks/useDialogState";
import { colors } from "@/theme/overrides/colors";

import DeletePlannedMealDialog from "./Dialogs/DeletePlannedMealDialog";
import PlannedMealFormDialog from "./Dialogs/PlannedMealFormDialog";
import { PlannedMeal } from "../store/PlannedMeal";

interface Props {
  plannedMeal: PlannedMeal;
}

const useStyles = makeStyles()((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "100%",
    padding: theme.spacing(2),
  },
  meal: {
    fontWeight: "bold",
  },
  button: {
    border: "2px solid #c0c5cd",
    padding: theme.spacing(1.5),
    marginRight: theme.spacing(2),
    "& .MuiSvgIcon-root": {
      fontSize: "1rem",
      color: colors.gray,
    },
  },
}));

const PlannedMealHeader: React.FC<Props> = observer(({ plannedMeal }) => {
  const { classes } = useStyles();
  const plannedMealFormDialog = useDialogState();
  const deletePlannedMealDialog = useDialogState();

  return (
    <div className={classes.root}>
      <Box>
        <Typography className={classes.meal}>{plannedMeal.label}</Typography>
        <Typography variant="caption" color="textSecondary">
          {format(plannedMeal.recommendedTime, "p")}
        </Typography>
      </Box>
      <Box display="flex" width="100%">
        <IconButton
          className={classes.button}
          size="small"
          onClick={plannedMealFormDialog.show}
        >
          <BorderColorIcon fontSize="small" />
        </IconButton>
        <IconButton
          className={classes.button}
          size="small"
          onClick={deletePlannedMealDialog.show}
        >
          <DeleteIcon fontSize="small" />
        </IconButton>
      </Box>
      <PlannedMealFormDialog
        open={plannedMealFormDialog.shown}
        plannedMeal={plannedMeal}
        onClose={plannedMealFormDialog.hide}
        onSubmit={(values) => {
          plannedMeal.setMeal(values.meal);
          plannedMeal.setRecommendedTime(values.recommendedTime);
        }}
      />
      <DeletePlannedMealDialog
        open={deletePlannedMealDialog.shown}
        plannedMeal={plannedMeal}
        onClose={deletePlannedMealDialog.hide}
      />
    </div>
  );
});

export default PlannedMealHeader;
